import GroupContainer from "./GroupContainer";

export default GroupContainer;
